import { render, staticRenderFns } from "./OrderDescDialog.vue?vue&type=template&id=5056e678&scoped=true&lang=pug&"
import script from "./OrderDescDialog.vue?vue&type=script&lang=ts&"
export * from "./OrderDescDialog.vue?vue&type=script&lang=ts&"
import style0 from "./OrderDescDialog.vue?vue&type=style&index=0&id=5056e678&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5056e678",
  null
  
)

export default component.exports